var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLanguageIconTr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svgexport-6_2_",
    "data-name": "svgexport-6 (2)",
    transform: "translate(-0.251 -0.251)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_31",
    "data-name": "Ellipse 31",
    cx: 9,
    cy: 9,
    r: 9,
    transform: "translate(0.251 0.251)",
    fill: "#e53030"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12247",
    "data-name": "Group 12247",
    transform: "translate(4.468 5.415)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5567",
    "data-name": "Path 5567",
    d: "M20.844,15.32l.871-1.119-1.34.378-.785-1.239-.062,1.477-1.308.369,1.271.5-.061,1.451.878-1.128,1.3.514Z",
    transform: "translate(-12.149 -11.046)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5568",
    "data-name": "Path 5568",
    d: "M12.2,16.4a3.055,3.055,0,0,1-2.987-3.122A3.056,3.056,0,0,1,12.2,10.154a2.552,2.552,0,0,1,2.446,1.408,3.284,3.284,0,0,0-3.226-2.173,3.754,3.754,0,0,0-3.67,3.834,3.752,3.752,0,0,0,3.67,3.833A2.953,2.953,0,0,0,14.3,15.445a2.209,2.209,0,0,1-2.1.952Z",
    transform: "translate(-7.752 -9.385)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguageIconTr);
export default __webpack_public_path__ + "static/media/language-icon-tr.fb06bf7143d5e616693e913e79b26b48.svg";
export { ForwardRef as ReactComponent };